import { Store } from "../../Store.types";

export const overlaySelector = (state: Store): Store["overlay"] => state.overlay;

export const overviewSelector = (state: Store): Store["overview"] => state.overview;
